var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-error',{attrs:{"no-appbar":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("404")]},proxy:true}])},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Désolé, la ressource n'existe pas.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }